import IntervencionC3ApiRepository from '@/modules/intervencion-c3/infrastructure/IntervencionC3ApiRepository'
import GetObservacionesIntervencionActiva from '@/modules/intervencion-c3/application/GetObservacionesIntervencionActiva'

const repository = new IntervencionC3ApiRepository()

export default {
  namespaced: true,
  state: {
    observaciones: [],
    loading: false,
  },
  getters: {
    getObservaciones: (state) => state.observaciones,
    getLoading: (state) => state.loading,
  },
  mutations: {
    SET_OBSERVACIONES(state, observaciones) {
      state.observaciones = observaciones
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    CLEAR_OBSERVACIONES(state) {
      state.observaciones = []
    },
  },
  actions: {
    async fetchObservacionesIntervencionActiva({ commit }, type) {
      commit('SET_LOADING', true)
      try {
        const observaciones = await new GetObservacionesIntervencionActiva(repository).execute(type)
        commit('SET_OBSERVACIONES', Array.isArray(observaciones) ? observaciones : [])
      } catch (error) {
        console.error('[intervencionC3] fetchObservacionesIntervencionActiva failed:', error)
        commit('SET_OBSERVACIONES', [])
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },
    clearObservaciones({ commit }) {
      commit('CLEAR_OBSERVACIONES')
    },
  },
}
